import { TrendingUp, ShieldCheck, Coins, MapPin, Quote } from "lucide-react";
import { opportunities, whatsappUrl } from "../mock";

const iconMap = { TrendingUp, ShieldCheck, Coins, MapPin };

export default function Opportunity() {
  return (
    <section id="oportunidade" className="py-20 bg-slate-50 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="relative max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold mb-4">
            Por que agora?
          </div>
          <h2 className="text-slate-900 text-3xl md:text-5xl font-extrabold leading-tight">
            A Maior Oportunidade do <br className="hidden md:block" />
            Setor de <span className="green-gradient-text">Energia no Brasil</span>
          </h2>
          <p className="mt-5 text-slate-600 max-w-2xl mx-auto">
            O mercado livre de energia está em plena expansão e você pode fazer parte dessa revolução energética, ajudando pessoas a economizarem e ganhando por isso.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {opportunities.map((o) => {
            const Icon = iconMap[o.icon];
            return (
              <div
                key={o.title}
                className="relative bg-white rounded-2xl border border-slate-200 p-6 hover:border-emerald-400/60 hover:shadow-xl hover:-translate-y-1 transition-all"
              >
                <div className="w-12 h-12 rounded-xl bg-emerald-100 grid place-items-center text-emerald-600 mb-4">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-slate-900 font-bold text-xl">{o.title}</h3>
                <p className="mt-2 text-slate-600 leading-relaxed">{o.text}</p>
                <div className="absolute top-4 right-4 w-24 h-24 rounded-full bg-emerald-100/40 blur-2xl" />
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-2xl bg-gradient-to-r from-emerald-800 to-emerald-700 text-white p-8 md:p-10 text-center">
          <Quote className="w-8 h-8 text-amber-300 mx-auto mb-3" />
          <p className="text-lg md:text-xl italic font-medium max-w-3xl mx-auto">
            “Enriquecer vidas e impactar o mundo com soluções sustentáveis e inovadoras.”
          </p>
          <p className="mt-3 text-emerald-200 text-sm">— Missão iGreen Energy</p>
          <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm mt-6">
            Chamar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
